import React from "react";
import { useTranslation } from "../i18n/LanguageContext";

export default function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();

  return (
    <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden text-xs">
      <button
        onClick={() => setLanguage("en")}
        className={`px-2.5 py-1 font-medium transition ${
          language === "en"
            ? "bg-indigo-600 text-white"
            : "bg-white text-gray-600 hover:bg-gray-50"
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage("es")}
        className={`px-2.5 py-1 font-medium transition ${
          language === "es"
            ? "bg-indigo-600 text-white"
            : "bg-white text-gray-600 hover:bg-gray-50"
        }`}
      >
        ES
      </button>
    </div>
  );
}
